import { bindable } from 'aurelia-framework';

class ProductExtrasContainer {
  @bindable selectedAccount = null;
  @bindable selectedProduct = null;
  @bindable route = '#';
  loading = false;
  extras = null;
  /**
   * @param {AppErrorPublisher}    appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}          errorParser          Used for error parsing.
   * @param {ProductFeedsProducts} productFeedsProducts To get FeedsProducts.
   */
  constructor(appErrorPublisher, errorParser, productFeedsProducts) {
    'inject';

    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productExtrasErrorParser = errorParser.wrap();
    this._appErrorPublisher = appErrorPublisher;
    this._productFeedsProducts = productFeedsProducts;
  }
  selectedAccountChanged() {
    if (!this.loading && this.selectedProduct) {
      this._loadExtras();
    }
  }
  selectedProductChanged() {
    if (!this.loading && this.selectedAccount) {
      this._loadExtras();
    }
  }
  _loadExtras() {
    this.loading = true;
    this._productFeedsProducts.getProductExtras(
      this.selectedAccount.id,
      this.selectedProduct.id,
    )
    .then((extras) => {
      this.extras = extras;
    })
    .catch((error) => {
      const parsedError = this._productExtrasErrorParser(
        error,
        'There was an error loading the extras',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { ProductExtrasContainer };
